const updateCartCount = (count) => {
  const cartCountEl = document.querySelector('[data-cart-count]');
  if (!cartCountEl) return;
  cartCountEl.textContent = count;
  cartCountEl.classList.toggle('hidden', Number(count) === 0);
};

export default updateCartCount;
